export const pastelColour = str => {

  //TODO: adjust base colour values below based on theme
  const baseRed = 150
  const baseGreen = 50
  const baseBlue = 150

  //lazy seeded random hack to get values from 0 - 256
  //for seed just take bitwise XOR of first two chars
  let seed = str.charCodeAt(0) ^ str.charCodeAt(1)
  const rand_1 = Math.abs((Math.sin(seed++) * 10000)) % 256
  const rand_2 = Math.abs((Math.sin(seed++) * 10000)) % 256
  const rand_3 = Math.abs((Math.sin(seed++) * 10000)) % 256

  //build colour
  const red = Math.round((rand_1 + baseRed) / 2)
  const green = Math.round((rand_2 + baseGreen) / 2)
  const blue = Math.round((rand_3 + baseBlue) / 2)

  return `rgba(${red}, ${green}, ${blue}, 1)`
}
